import { render } from "./DeleteTeammateDialog.vue?vue&type=template&id=6392b52e"
import script from "./DeleteTeammateDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTeammateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__